export class LayoutClasses {

    /**
     * When dragging a box, to keep the cursor on move
     */
    static widgetBoxDragActiveClass = "ic3SelectedBoxDragActive";

    static widgetSelector = "ic3WidgetSelected";

    static widgetBoxSelected = "ic3WidgetBoxSelected";

    static widgetBoxSelectedEx = "ic3WidgetBoxSelectedEx";

}

export declare type LayoutClassKey = keyof LayoutClasses;

